/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosPoolListInfo } from '../models/AptosPoolListInfo';
import type { DefiProjectDetailInfo } from '../models/DefiProjectDetailInfo';
import type { ProtocolCategoryListInfo } from '../models/ProtocolCategoryListInfo';
import type { ProtocolListInfo } from '../models/ProtocolListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosDefiControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ProtocolListInfo OK
     * @throws ApiError
     */
    public getProtocolList1({
        sort = 'TVL',
        direction = 'DESC',
        page = 1,
        size = 50,
    }: {
        sort?: 'CATEGORY' | 'TVL' | 'TVL_CHANGE_1D' | 'TVL_CHANGE_7D' | 'TVL_CHANGE_30D' | 'MCAP_N_TVL',
        direction?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<ProtocolListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/defi/protocol/list',
            query: {
                'sort': sort,
                'direction': direction,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns ProtocolCategoryListInfo OK
     * @throws ApiError
     */
    public getProtocolCategoryList1(): CancelablePromise<ProtocolCategoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/defi/protocol/category/list',
        });
    }

    /**
     * @returns DefiProjectDetailInfo OK
     * @throws ApiError
     */
    public getProjectDetail1({
        projectId,
    }: {
        projectId: string,
    }): CancelablePromise<DefiProjectDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/defi/project',
            query: {
                'projectId': projectId,
            },
        });
    }

    /**
     * @returns AptosPoolListInfo OK
     * @throws ApiError
     */
    public getAptosPoolList({
        sortField = 'TVL',
        sortDirection = 'DESC',
        page = 1,
        size = 50,
    }: {
        sortField?: 'TVL' | 'APY' | 'APY_BASE' | 'APY_REWARD' | 'APY_AVG_30D',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<AptosPoolListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/defi/pool/list',
            query: {
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

}
